import { ReactNode } from "react"
import { CardVariant } from "../../models/CardVariant"
import { classNamesOrEmpty } from "../../style/common"
import { FIREBASE_STORAGE_URL } from "../../app-settings"

export type CardVariantImageProps = {
    variant: CardVariant,
    overlay?: ReactNode,
    footer?: ReactNode,
    classNames?: {
        container?: string | undefined,
        image?: string | undefined
    }
}

export function CardVariantImage(props: CardVariantImageProps) {
    return (
        <div className={`relative ${classNamesOrEmpty(props.classNames?.container)}`}>
            <div className="group relative">
                <div className="w-full relative">
                    {
                        !!props.overlay &&
                        props.overlay
                    }

                    <img
                        style={{ aspectRatio: "143/200", zIndex: "1" }}
                        src={`${FIREBASE_STORAGE_URL}/images/cards/${props.variant.imageId}.jpg`}
                        alt={`${props.variant?.card?.name} image`}
                        loading="lazy"
                        className={`card relative rounded-2xl w-full ${classNamesOrEmpty(props.classNames?.image)}`} />
                </div>
                {
                    !!props.footer &&
                    props.footer
                }
            </div>
        </div>
    )
}